class ZahavMommyMePicker extends HTMLElement {
  connectedCallback() {
    if (this.dataset.zahavMmInit) return;
    this.dataset.zahavMmInit = 'true';

    this.rows = Array.prototype.slice.call(this.querySelectorAll('.zahav-mm-picker__row[data-variant-id]'));
    this.totalEl = this.querySelector('.zahav-mm-picker__total-price');
    this.totalOriginalEl = this.querySelector('.zahav-mm-picker__total-price-original');
    this.savingsNoteEl = this.querySelector('.zahav-mm-picker__savings-note');
    this.bundleThreshold = parseInt(this.dataset.bundleThreshold, 10) || 2;
    this.bundleDiscount = parseFloat(this.dataset.bundleDiscount) || 0;
    this.shippingBox = this.querySelector('.zahav-mm-picker__shipping-box');
    this.shippingTextEl = this.querySelector('.zahav-mm-picker__shipping-text');
    this.finalSaleNoteEl = this.querySelector('.zahav-mm-picker__final-sale-note');
    this.addButton = this.querySelector('.zahav-mm-picker__add-button');
    this.statusEl = this.querySelector('.zahav-mm-picker__status');

    if (!this.addButton) return;

    this.#wireRows();
    this.#wireAddButton();
    this.#recalc();
  }

  #formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  #recalc() {
    var total = 0;
    var kidsQty = 0;
    var adultQty = 0;

    this.rows.forEach(function (row) {
      var input = row.querySelector('.zahav-mm-picker__qty-input');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      var price = parseFloat(row.dataset.price) || 0;
      total += qty * price;
      row.classList.toggle('zahav-mm-picker__row--selected', qty > 0);
      if (row.dataset.isAdult === 'true') {
        adultQty += qty;
      } else {
        kidsQty += qty;
      }
    });

    var totalQty = kidsQty + adultQty;
    var bundleApplies = this.bundleDiscount > 0 && totalQty >= this.bundleThreshold;

    if (bundleApplies) {
      var discountedTotal = total * (1 - this.bundleDiscount);
      if (this.totalOriginalEl) {
        this.totalOriginalEl.textContent = this.#formatMoney(Math.round(total * 100));
        this.totalOriginalEl.hidden = false;
      }
      this.totalEl.textContent = this.#formatMoney(Math.round(discountedTotal * 100));
      if (this.savingsNoteEl) {
        this.savingsNoteEl.textContent = 'You saved ' + this.#formatMoney(Math.round((total - discountedTotal) * 100)) + ' (' + Math.round(this.bundleDiscount * 100) + '% bundle discount)';
        this.savingsNoteEl.hidden = false;
      }
    } else {
      if (this.totalOriginalEl) this.totalOriginalEl.hidden = true;
      this.totalEl.textContent = this.#formatMoney(Math.round(total * 100));
      if (this.savingsNoteEl) this.savingsNoteEl.hidden = true;
    }

    if (this.shippingBox && this.shippingTextEl) {
      if (adultQty > 0) {
        this.shippingTextEl.textContent = this.shippingTextEl.dataset.adultText;
        this.shippingBox.classList.add('zahav-mm-picker__shipping-box--mto');
        if (this.finalSaleNoteEl) this.finalSaleNoteEl.hidden = false;
      } else if (kidsQty > 0) {
        this.shippingTextEl.textContent = this.shippingTextEl.dataset.kidsText;
        this.shippingBox.classList.remove('zahav-mm-picker__shipping-box--mto');
        if (this.finalSaleNoteEl) this.finalSaleNoteEl.hidden = true;
      } else {
        this.shippingTextEl.textContent = this.shippingTextEl.dataset.emptyText;
        this.shippingBox.classList.remove('zahav-mm-picker__shipping-box--mto');
        if (this.finalSaleNoteEl) this.finalSaleNoteEl.hidden = true;
      }
    }

    this.addButton.disabled = total === 0 || kidsQty + adultQty === 0;
  }

  #wireRows() {
    var self = this;
    this.rows.forEach(function (row) {
      var input = row.querySelector('.zahav-mm-picker__qty-input');
      var decreaseBtn = row.querySelector('[data-action="decrease"]');
      var increaseBtn = row.querySelector('[data-action="increase"]');
      if (!input) return;

      var max = parseInt(input.getAttribute('max'), 10);
      if (isNaN(max)) max = 99;

      function clamp(value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) value = 0;
        if (value > max) value = max;
        return value;
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          input.value = clamp(parseInt(input.value, 10) - 1);
          self.#recalc();
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          input.value = clamp(parseInt(input.value, 10) + 1);
          self.#recalc();
        });
      }
      input.addEventListener('change', function () {
        input.value = clamp(input.value);
        self.#recalc();
      });
    });
  }

  #wireAddButton() {
    var self = this;
    this.addButton.addEventListener('click', function () {
      var items = [];
      self.rows.forEach(function (row) {
        var input = row.querySelector('.zahav-mm-picker__qty-input');
        if (!input) return;
        var qty = parseInt(input.value, 10) || 0;
        if (qty > 0) {
          items.push({ id: parseInt(row.dataset.variantId, 10), quantity: qty });
        }
      });
      if (items.length === 0) return;

      self.addButton.disabled = true;
      self.addButton.textContent = 'Adding...';
      self.statusEl.hidden = true;
      self.statusEl.removeAttribute('data-state');

      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add_failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          self.addButton.textContent = 'Added';
          self.statusEl.hidden = false;
          self.statusEl.textContent = 'Added to cart.';
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: { itemCount: cart.item_count, source: 'zahav-mommy-me-picker' }
              }
            })
          );
          setTimeout(function () {
            self.addButton.textContent = 'Add to Cart';
            self.#recalc();
          }, 1500);
        })
        .catch(function () {
          self.addButton.disabled = false;
          self.addButton.textContent = 'Add to Cart';
          self.statusEl.hidden = false;
          self.statusEl.setAttribute('data-state', 'error');
          self.statusEl.textContent = 'Something went wrong. Please try again.';
        });
    });
  }
}

if (!customElements.get('zahav-mommy-me-picker')) {
  customElements.define('zahav-mommy-me-picker', ZahavMommyMePicker);
}
